__turbopack_context__.v({
  "accent-lightblue": "uH_Kia_accent-lightblue",
  "accent-lightblue-subdued": "uH_Kia_accent-lightblue-subdued",
  "card": "uH_Kia_card",
  "compact": "uH_Kia_compact",
  "neutral": "uH_Kia_neutral",
  "pink": "uH_Kia_pink",
  "primary": "uH_Kia_primary",
  "yellow": "uH_Kia_yellow",
});
